import { TextField } from "@mui/material"
import SecurityIcon from '@mui/icons-material/Security';
import VerifiedIcon from '@mui/icons-material/VerifiedUser';
import { txt } from "../../../services/translation";

export default function Verification({show, user, error, onChange, verified}){

    return show && <>
        <p>{txt('verificationCodeSent')}</p>
            
        <p>{txt('enterVerificationCodeBelow')}</p>

        <TextField
            label={txt('verificationCode')}
            value={user.verificationCode || ''}
            onChange={e => onChange({...user, verificationCode: e.target.value})}
            required
            InputProps={{
                inputProps: {
                    pattern: "[0-9]{4}", 
                    minLength: 4, 
                    maxLength: 4,
                },
                endAdornment: verified ? 
                    <VerifiedIcon color='success'/> : 
                    <SecurityIcon color='action'/>
            }}
            error={error ? true : false}
            helperText={error && txt('invalidCodeMessage')}
            size='small'
        />

        <p>{txt('didNotReceiveEmail')}</p>
    </>

}